import { render, staticRenderFns } from "./SingleOtpInput.vue?vue&type=template&id=47f2a62a&scoped=true"
import script from "./SingleOtpInput.vue?vue&type=script&lang=js"
export * from "./SingleOtpInput.vue?vue&type=script&lang=js"
import style0 from "./SingleOtpInput.vue?vue&type=style&index=0&id=47f2a62a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2a62a",
  null
  
)

export default component.exports